export const GetCodesFromSampleComments = (codeList, comments) => {
	if(!codeList.regex || !codeList.code){
		console.log("Error: codeList is not of the correct shape")
		return
	}
	
	const fixedComments = comments.toLowerCase()
	
	let codes = []
	
	codeList.forEach(code => {
		if(code.regex.test(fixedComments)){
			codes.push(code.code)
		}
	})
	
	return codes
}